import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Department } from '@map/models';

@Injectable({
    providedIn: 'root',
})
export class DepartmentService extends BaseService {
    constructor() {
        super();
        this.setApiName('Departments');
    }

    override mapResponseToObject<T>(response: any): T {
        return new Department(response) as any;
    }
    override mapArrayResponseToObject<T>(response: any): T {
        return response.map((responseJson: any) => new Department(responseJson));
    }
}
